import React, { FunctionComponent } from 'react';
import { Icon } from '@/components';
import StylesType from '@/types/StylesType';
import { Row, Col } from 'antd';


export interface SyncRoomListProps extends StylesType {
    prefixCls?: string;
    slaveIds: any[];
    masterId: string;
    masterName: string;
    actions: any;
    totalId?: number;

    sizeType: string;
    sizeTypeChange: (type: string) => void;

    rotateType: string;
    rotateTypeChange: () => void;

    totalCheckedIndex: number;
    totalCheckedIndexChange: (e: any, index: number) => void;

    soundType: string;
    soundTypeChange: () => void;

}

//自定义下拉弹框
export const DropDownTotal: React.FC<SyncRoomListProps> = props => {
    const { prefixCls, rotateType, sizeType, className, totalId, actions } = props;
    const titleName = `${prefixCls}-${rotateType}-${sizeType}-total-view-dropDown`;
    // console.log(totalId)
    return (
        <Row className={`${className}`}>
            <Col onClick={() => { actions.changeMain(totalId) }} className={`${titleName}-dropDownTitle`}>设为主机</Col>
            <Col onClick={() => { actions.backspace(totalId) }} className={`${titleName}-dropDownTitle`}>返回键</Col>
            <Col onClick={() => { actions.home(totalId) }} className={`${titleName}-dropDownTitle`}>首页键</Col>
            <Col onClick={() => { actions.menu(totalId) }} className={`${titleName}-dropDownTitle`}>菜单键</Col>
        </Row>
    )
}
//自定义音量加减
export const SoundSet: React.FC<SyncRoomListProps> = props => {
    const { prefixCls, className, rotateType, masterId, actions } = props;
    return (
        <Row className={`${prefixCls}-${rotateType}-sound ${className}`}>
            <Col onClick={() => { actions.volumeUp(masterId) }} className={`${prefixCls}-${rotateType}-sound-up`}>
                <Icon type='iconvolum' />
            </Col>
            <Col onClick={() => { actions.volumeDown(masterId) }} className={`${prefixCls}-${rotateType}-sound-down`}>
                <Icon type='iconvolum-' />
            </Col>
        </Row>
    )
}

//云机同步-主机
export const SyncMaster: React.FC<SyncRoomListProps> = props => {

    const { prefixCls, rotateType, masterId, masterName, soundType, soundTypeChange, actions, rotateTypeChange } = props;
    const classNameMaster = `${prefixCls}-${rotateType}-master`;
    return (
        <Col className={`${classNameMaster}`}>
            <Row type='flex' justify='center'>
                <Row className={`${classNameMaster}-top`} type='flex' justify='space-between'>
                    <span className={`${classNameMaster}-top-name`}>{masterName}</span>
                    <Icon className={`${classNameMaster}-top-icon`} type={soundType === 'show' ? 'iconxialajiantou' : 'iconup'} onClick={soundTypeChange} />
                </Row>
                <Row>
                    <SoundSet {...props} className={soundType === 'show' ? `${prefixCls}-sound-checked` : ''} />
                    <Row className={`${classNameMaster}-play-out`}>
                        <Row id={masterId} className={`${classNameMaster}-play`}>

                        </Row>
                    </Row>
                </Row>

                <Row className={`${classNameMaster}-bottom`} type='flex' justify='space-between'>
                    <Col onClick={() => actions.backspace(masterId)} className={`${classNameMaster}-bottom-icon`} span={6}><Icon type={'iconback'} /></Col>
                    <Col onClick={() => actions.home(masterId)} className={`${classNameMaster}-bottom-icon`} span={6}><Icon type={'iconhome'} /></Col>
                    <Col onClick={() => actions.menu(masterId)} className={`${classNameMaster}-bottom-icon`} span={6}><Icon type={'iconsider'} /></Col>
                    <Col onClick={rotateTypeChange} className={`${classNameMaster}-bottom-icon`} span={6}><Icon type={'iconroate'} /></Col>
                </Row>
            </Row>
        </Col>
    )

}

//云机同步-从机
export const SyncTotal: React.FC<SyncRoomListProps> = props => {

    const { prefixCls, rotateType, sizeType, sizeTypeChange, slaveIds, totalCheckedIndex, totalCheckedIndexChange } = props;
    const classNameTotal = `${prefixCls}-${rotateType}-${sizeType}-total`;
    console.log(slaveIds);
    const viewList = [{
        'china': '大视图',
        'english': 'big'
    }, {
        'china': '中视图',
        'english': 'medium'
    }, {
        'china': '小视图',
        'english': 'small'
    }];

    return (
        <Col className={`${classNameTotal}`}>
            <Row className={`${classNameTotal}-set`} type='flex' justify='end' align='middle'>
                <p>视图大小：</p>
                {
                    viewList.map(item => {
                        return item.english === sizeType ?
                            <Col onClick={() => sizeTypeChange(item.english)} key={item.english} className={`${classNameTotal}-set-size ${classNameTotal}-set-checked`}>{item.china}</Col> :
                            <Col onClick={() => sizeTypeChange(item.english)} key={item.english} className={`${classNameTotal}-set-size`}>{item.china}</Col>
                    })
                }
            </Row>
            <Row className={`${classNameTotal}-view`}>
                {slaveIds.map((item, index) => {
                    if (index > 0) {
                        return <Col key={index} style={{ marginRight: 20, marginBottom: 20, float: 'left' }}>
                            <Row className={`${classNameTotal}-view-top`} type='flex' justify='space-between'>
                                <span className={`${classNameTotal}-view-top-name`}>{item.deviceName || item.phoneId}</span>
                                <Icon type='iconcaidanlan' className={index === totalCheckedIndex ? `${classNameTotal}-view-top-icon ${classNameTotal}-view-top-icon-checked` : `${classNameTotal}-view-top-icon`} onClick={(e) => totalCheckedIndexChange(e, index)} />
                            </Row>
                            <Row>
                                <DropDownTotal {...props} totalId={item.phoneId} className={index === totalCheckedIndex ? `${classNameTotal}-view-dropDown ${classNameTotal}-view-dropDown-checked` : `${classNameTotal}-view-dropDown`} />
                                <Row className={`${classNameTotal}-view-play-out`}>
                                    <Row id={item.phoneId} className={`${classNameTotal}-view-play`}>

                                    </Row>
                                </Row>
                            </Row>
                        </Col>
                    }
                    return null
                })}
            </Row>
        </Col>
    )

}

export const SyncRoomList: FunctionComponent<SyncRoomListProps> = props => {

    const { prefixCls } = props;

    return (
        <Row className={prefixCls} type='flex' justify='space-between'>
            <SyncMaster {...props} />
            <SyncTotal {...props} />
        </Row>
    )

}

export default SyncRoomList;

SyncRoomList.defaultProps = {
    prefixCls: 'gc-async-example'
}

